import React from 'react';
import { Watermark } from '../components/Section';
import SEO from '../lib/SEO';

const content = {
  privacy: {
    title: 'Privacy Policy',
    body: [
      { h: 'Overview', p: 'Apex Quality Control (“AQC”, “we”, “us”) is committed to protecting your privacy. This Policy explains how we collect, use and protect information you provide when using our website and services.' },
      { h: 'Data we collect', p: 'We collect contact details you submit through forms (name, company, email, phone, and message), and standard analytics data such as browser type, referring pages and interaction events.' },
      { h: 'How we use data', p: 'We use submissions to respond to enquiries and deliver our services. Analytics data is used to improve site performance and content.' },
      { h: 'Cookies', p: 'We use strictly necessary cookies and, with consent, analytics and marketing cookies. See our Cookie Policy for details.' },
      { h: 'Retention', p: 'We retain contact enquiries for as long as necessary to provide the requested service and to comply with our legal obligations.' },
      { h: 'Your rights', p: 'You may request access, correction or deletion of your personal data by emailing info@aqc.so.' },
    ],
  },
  cookies: {
    title: 'Cookie Policy',
    body: [
      { h: 'What are cookies', p: 'Cookies are small text files stored on your device that help websites work and provide reporting information.' },
      { h: 'Categories we use', p: 'Strictly necessary (site function), Analytics (anonymous usage insights) and Marketing (personalised content).' },
      { h: 'Managing preferences', p: 'You can change your consent at any time via the cookie banner. Strictly necessary cookies cannot be disabled as the site relies on them to function.' },
    ],
  },
  terms: {
    title: 'Terms of Use',
    body: [
      { h: 'Acceptance', p: 'By accessing this website you agree to these Terms of Use. If you do not agree, please do not use the site.' },
      { h: 'Content', p: 'All content on this site is provided for informational purposes and is owned by AQC or used with permission. You may not reproduce, modify or distribute content without written permission.' },
      { h: 'Services', p: 'Descriptions of services do not constitute an offer. All engagements are subject to a signed agreement between AQC and the client.' },
      { h: 'Liability', p: 'AQC provides the website “as is” and disclaims warranties to the fullest extent permitted by law. AQC is not liable for indirect or consequential loss arising from use of this website.' },
    ],
  },
};

export default function Legal({ doc = 'privacy' }) {
  const c = content[doc] || content.privacy;
  return (
    <div className="font-sans-body">
      <SEO path={`/${doc === 'privacy' ? 'privacy' : doc === 'cookies' ? 'cookies' : 'terms'}`} />
      <section className="relative overflow-hidden">
        <Watermark opacity={0.04} />
        <div className="container-aqc relative py-16 text-center">
          <span className="eyebrow">Legal</span>
          <h1 className="mt-4 font-serif text-4xl sm:text-5xl text-aqc-navy">{c.title}</h1>
        </div>
      </section>
      <section className="pb-20">
        <div className="container-aqc max-w-3xl">
          <div className="bg-white border border-aqc-line rounded-2xl p-8 shadow-sm space-y-6">
            {c.body.map((s) => (
              <div key={s.h}>
                <h2 className="font-serif text-xl text-aqc-navy">{s.h}</h2>
                <p className="mt-2 text-aqc-muted leading-relaxed">{s.p}</p>
              </div>
            ))}
            <p className="text-xs text-aqc-muted pt-4 border-t border-aqc-line">Last updated: 2025 · Editable from the admin panel.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
